/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Paint Bucket",
  size: 20
}

const SvgPaintBucket = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M10.21 1L0 11.21l8.1 8.1L18.31 9.1 10.21 1zm6.68 8.1L15 11H1.7l8.51-8.58 6.68 6.68z" />
    <path fill="none" strokeWidth={1.1} d="M6.42 2.33l5.28 5.28" />
    <path d="M18.49 12S20 14.06 20 15.36c0 .92-.76 1.64-1.51 1.64S17 16.28 17 15.36c0-1.3 1.49-3.36 1.49-3.36z" />
  </Svg>
)

SvgPaintBucket.defaultProps = defaultProps
export default SvgPaintBucket
